import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface IKanbanKart {
  id: string;
  baslik: string;
  aciklama?: string;
  etiket?: string;
  etiketRenk?: string;
  avatar?: string;
}

@Component({
  selector: 'widget-kanban-sutun',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sutun">
      <div class="sutun-ust-cizgi" [style.background]="renk()"></div>
      <div class="sutun-baslik">
        <span class="baslik-metin">{{ baslik() }}</span>
        <span class="kart-sayisi" [style.background]="renk() + '22'" [style.color]="renk()">{{ kartlar().length }}</span>
      </div>
      <div class="kartlar-listesi">
        @for (kart of gorunenKartlar(); track kart.id) {
          <div class="kart">
            <div class="kart-ust">
              <span class="kart-baslik">{{ kart.baslik }}</span>
              @if (kart.avatar) {
                <img class="kart-avatar" [src]="kart.avatar" alt="" />
              }
            </div>
            @if (kart.aciklama) {
              <div class="kart-aciklama">{{ kart.aciklama }}</div>
            }
            @if (kart.etiket) {
              <span class="kart-etiket" [style.background]="(kart.etiketRenk || renk()) + '1a'" [style.color]="kart.etiketRenk || renk()">{{ kart.etiket }}</span>
            }
          </div>
        }
        @if (kalanSayi() > 0) {
          <div class="daha-fazla">+{{ kalanSayi() }} daha</div>
        }
      </div>
    </div>
  `,
  styles: [`
    :host { display: block; }
    .sutun {
      border-radius: 10px; overflow: hidden;
      background: var(--py-arkaplan-ikincil, rgba(255,255,255,0.04));
    }
    .sutun-ust-cizgi { height: 3px; }
    .sutun-baslik {
      display: flex; align-items: center; justify-content: space-between;
      padding: 10px 12px 6px;
    }
    .baslik-metin {
      font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.4px;
      color: var(--py-metin-ikincil, #999);
    }
    .kart-sayisi {
      font-size: 11px; font-weight: 700; min-width: 20px; height: 20px;
      border-radius: 10px; display: inline-flex; align-items: center; justify-content: center;
      padding: 0 6px;
    }
    .kartlar-listesi {
      padding: 4px 8px 8px; display: flex; flex-direction: column; gap: 6px;
      overflow-y: auto; max-height: 320px;
    }
    .kart {
      padding: 8px 10px; border-radius: 8px;
      background: var(--py-arkaplan, rgba(255,255,255,0.06));
      border: 1px solid rgba(255,255,255,0.06);
      transition: transform 0.15s, box-shadow 0.15s;
      cursor: default;
      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 3px 10px rgba(0,0,0,0.18);
      }
    }
    .kart-ust { display: flex; align-items: flex-start; gap: 8px; }
    .kart-baslik {
      flex: 1; font-size: 13px; font-weight: 600; line-height: 1.35;
      color: var(--py-metin, #e0e0e0);
      display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
    }
    .kart-avatar {
      width: 24px; height: 24px; border-radius: 50%; flex-shrink: 0;
      object-fit: cover; border: 1.5px solid rgba(255,255,255,0.1);
    }
    .kart-aciklama {
      font-size: 11px; line-height: 1.4; margin-top: 4px;
      color: var(--py-metin-ikincil, #888);
      display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
    }
    .kart-etiket {
      display: inline-block; margin-top: 6px; padding: 2px 8px;
      border-radius: 10px; font-size: 10px; font-weight: 600;
    }
    .daha-fazla {
      text-align: center; padding: 6px; font-size: 12px; font-weight: 500;
      color: var(--py-metin-ikincil, #888); opacity: 0.7;
    }
  `],
})
export class KanbanSutunComponent {
  baslik = input('');
  renk = input('#1890ff');
  kartlar = input<IKanbanKart[]>([]);
  maxKart = input(5);

  gorunenKartlar = computed(() => this.kartlar().slice(0, this.maxKart()));
  kalanSayi = computed(() => Math.max(0, this.kartlar().length - this.maxKart()));
}
